import { useRequiredContext } from "@redotech/react-util/context";
import Edit02Icon from "@redotech/redo-icons/edit-02.svg";
import Edit02FilledIcon from "@redotech/redo-icons/edit-02_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import {
  OrderManagementPermissions,
  ReturnsAndClaimsPermissions,
} from "@redotech/redo-model/permissions";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const OrderEditsItem = memo(function OrderEditsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  const hasPermissionToViewItem = useHasPermission(
    OrderManagementPermissions.VIEW_ORDER,
    ReturnsAndClaimsPermissions.VIEW_RETURN,
    ReturnsAndClaimsPermissions.MANAGE_WARRANTY,
    ReturnsAndClaimsPermissions.MANAGE_PACKAGE_PROTECTION_CLAIM,
    OrderManagementPermissions.MANAGE_SHIPMENTS,
  );

  if (!hasPermissionToViewItem) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.orderEditsHref }}
      FilledIcon={Edit02FilledIcon}
      friendlyName="Order editing"
      id="order-edits"
      UnfilledIcon={Edit02Icon}
    />
  );
});
